/* -----------------Globals--------------- */
import { useEffect } from "react";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------UI--------------- */
import { Dialog } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { trackCustomEvent } from "analytics";

/* -----------------Child components--------------- */
import FeedbackForm from "../FeedbackForm";

/* -----------------Third party libraries--------------- */

import { events } from "@constants/tracking";
import type { FeedbackType } from "@features/feedback/helpers";
import DialogWrapper from "@memorang/ui/src/components/DialogWrapper";
import { ToastProvider } from "@memorang/ui/src/components/Toast";
import type { IconType } from "@memorang/ui/src/types";
import { useKeyboard } from "@react-native-community/hooks";
import { useTranslation } from "react-i18next";
/* -----------------Constants--------------- */
import { dialogTexts } from "../../constants";
type Props = {
	visible: boolean;
	handleDismiss: () => void;
	view: string;
	feedbackTitle?: string;
	feedbackSubtitle?: string;
	feedbackIcon?: IconType;
	feedbackCta?: string;
	itemId?: string;
	itemFeedbackRating?: "positive" | "negative";
	sessionId?: number;
	threadId?: string;
	runId?: string;
	type?: FeedbackType;
	featureName?: string;
};

export const FeedbackDialog = ({
	visible,
	handleDismiss,
	view,
	feedbackTitle,
	feedbackSubtitle,
	feedbackIcon = "comment-quote-outline",
	feedbackCta,
	itemId,
	itemFeedbackRating,
	sessionId,
	threadId,
	runId,
	type,
	featureName,
}: Props) => {
	const { t } = useTranslation();
	const config = dialogTexts.feedback;
	const { keyboardHeight } = useKeyboard();

	useEffect(() => {
		if (visible) {
			trackCustomEvent({
				eventName: events.dialogOpened,
				type: "Feedback",
			});
		}
	}, [visible]);

	const handleDismissFeedback = () => {
		handleDismiss();
		trackCustomEvent({
			eventName: events.dialogClosed,
			type: "Feedback",
		});
	};

	return (
		<>
			<DialogWrapper
				visible={visible}
				handleClose={handleDismissFeedback}
				maxWidth="xs"
				bottom={keyboardHeight ? keyboardHeight - 200 : 0}
			>
				<Dialog.Icon
					icon={(props) => (
						<Icon
							name={feedbackIcon}
							{...props}
							accessibilityLabel="Feedback Icon"
						/>
					)}
				/>
				<Dialog.Title
					style={{
						textAlign: "center",
					}}
				>
					{feedbackTitle || t(config.title)}
				</Dialog.Title>
				<Dialog.Content>
					<ToastProvider>
						<FeedbackForm
							view={view || "profile"}
							handleDismiss={handleDismissFeedback}
							feedbackSubtitle={feedbackSubtitle}
							itemId={itemId}
							itemFeedbackRating={itemFeedbackRating}
							sessionId={sessionId}
							threadId={threadId}
							runId={runId}
							type={type}
							featureName={featureName}
							feedbackCta={feedbackCta}
						/>
					</ToastProvider>
				</Dialog.Content>
			</DialogWrapper>
		</>
	);
};
